import { Autocomplete, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import useProviderRequest from '../../requests/ProviderRequest';
import lookupManager from '../../utils/lookupManager';

const ProviderPicker = ({
  providerId,
  optionName,
  baseOnly = false,
  fullWidth = false,
  placeholder = null,
  required = false,
  disabled = false,
  onChange,
  errorHandler,
}) => {
  const [list, setList] = useState([]);
  const { getSelectProviders } = useProviderRequest();

  useEffect(() => {
    getProviderList();
  }, []);

  const getProviderList = async () => {
    const providers = await lookupManager.lookup('providers', async () => {
      const p = await getSelectProviders(errorHandler);
      p.sort((a, b) => a.provider_name.localeCompare(b.provider_name));
      return p;
    });

    setList(
      providers
        .filter((p) => {
          if (!baseOnly) return true;
          return parseInt(p.copy_dlvry_from) === parseInt(p.provider_id);
        })
        .map((p) => ({ id: p.provider_id, label: p.provider_name }))
    );
  };

  const value = providerId ? list.find((p) => p.id === providerId) : {};

  return (
    <Autocomplete
      name={optionName || 'provider_id'}
      value={value || {}}
      size="small"
      onChange={(e, newValue) => {
        if (onChange) onChange(e, newValue);
      }}
      disabled={disabled || list.length === 0}
      fullWidth={fullWidth}
      options={list}
      getOptionLabel={(option) => option.label || ''}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      renderInput={(params) => (
        <TextField
          {...params}
          required={required}
          fullWidth={fullWidth}
          size="small"
          placeholder={placeholder}
        />
      )}
    />
  );
};

export default ProviderPicker;
